// Visual size ordering via CSS 'order' only. No DOM moves.
// Keeps behavior intact and prevents "all unavailable" bugs.

(function () {
  const SIZE_ORDER = ["XS","S","S/M","M","M/L","L","L/XL","XL","2XL"];

  const norm = s => (s || "").toUpperCase().replace(/\s+/g, "");

  function setOrders(root) {
    const lists = root.querySelectorAll('fieldset[data-option-slug*="size" i] ul.swatches');
    lists.forEach(ul => {
      // Only touch button-style swatches (your markup already)
      const items = ul.querySelectorAll(':scope > li');
      items.forEach((li, idx) => {
        // Prefer the label's title attribute; fallback to text
        const label = li.querySelector('label[title]');
        const raw = (label && label.getAttribute('title')) || li.textContent || "";
        const key = norm(raw.trim());

        const base = SIZE_ORDER.indexOf(key);
        // Unknown sizes go after known ones, keep their relative order stable
        const visualOrder = (base === -1 ? 100 + idx : base);

        li.style.order = String(visualOrder);
      });
    });
  }

  // Apply now
  function applyAll() { setOrders(document); }

  // Initial load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyAll, { once: true });
  } else {
    applyAll();
  }

  // Re-apply on common Shopify/Concept events without touching DOM
  const events = [
    "shopify:section:load",
    "variant:change",
    "product:variant-change",
    "quick-add:updated",
    "product-quickview:open",
    "modal:open",
    "change",
    "click"
  ];
  events.forEach(e => document.addEventListener(e, applyAll, true));

  // Lightweight observer to catch AJAX-inserted swatch blocks
  const mo = new MutationObserver(muts => {
    for (const m of muts) {
      if (!m.addedNodes) continue;
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        if (n.matches?.('fieldset[data-option-slug*="size" i], ul.swatches') ||
            n.querySelector?.('fieldset[data-option-slug*="size" i] ul.swatches')) {
          setOrders(document);
          return;
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
